var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "satellite 1",
    clipPath: "url(#clip0_4872_41887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00003 2.0002C8.72401 2.0002 8.5 2.22421 8.5 2.50023C8.5 2.77625 8.72401 3.00026 9.00003 3.00026C10.3791 3.00026 11.5002 4.12233 11.5002 5.50042C11.5002 5.77644 11.7242 6.00045 12.0002 6.00045C12.2762 6.00045 12.5003 5.77644 12.5003 5.50042C12.5003 3.5703 10.9302 2.0002 9.00003 2.0002Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00003 0C8.72401 0 8.5 0.224014 8.5 0.500031C8.5 0.776049 8.72401 1.00006 9.00003 1.00006C11.4812 1.00006 13.5003 3.01919 13.5003 5.50034C13.5003 5.77636 13.7243 6.00038 14.0003 6.00038C14.2764 6.00038 14.5004 5.77636 14.5004 5.50034C14.5004 2.46715 12.0322 0 9.00003 0Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.2422 9.03551L5.46367 1.25702C5.26865 1.06201 4.95163 1.06201 4.75662 1.25702C3.62355 2.39109 2.99951 3.89719 2.99951 5.50029C2.99951 6.36734 3.18752 7.20339 3.53555 7.97044C3.99257 7.3844 4.69762 7.00038 5.49967 7.00038C6.88075 7.00038 7.99982 8.11945 7.99982 9.50054C7.99982 10.1826 7.72481 10.7996 7.28178 11.2506C7.83281 11.4147 8.40985 11.5007 8.99989 11.5007C10.603 11.5007 12.1091 10.8766 13.2422 9.74255C13.4372 9.54754 13.4372 9.23052 13.2422 9.03551Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.99998 13.0011H7.80891L6.57783 10.5399C6.83785 10.2699 6.99986 9.9049 6.99986 9.50087C6.99986 8.67282 6.32781 8.00078 5.49976 8.00078C4.67171 8.00078 3.99967 8.67282 3.99967 9.50087C3.99967 9.9049 4.16168 10.2699 4.42069 10.5399L3.19062 13.0011H1.99954C1.72353 13.0011 1.49951 13.2251 1.49951 13.5011V15.5002C1.49951 15.7763 1.72353 16.0003 1.99954 16.0003H8.99998C9.276 16.0003 9.50001 15.7763 9.50001 15.5002V13.5011C9.50001 13.2251 9.276 13.0011 8.99998 13.0011Z",
    fill: "#979EA8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_41887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connectionIcon.ec821e28d1c378b79cb165aef44e8d09.svg";
export { ForwardRef as ReactComponent };